/** @class PageGlobalStyleMixin */
/** @method */
export var PageGlobalStyleMixin = function PageGlobalStyleMixin() {
  return "\n    body {\n        margin: 0;\n    }\n";
};